<template>
  <div>
    <div v-if="emergencyContactsWithSections">
      <div v-for="(section, index) in emergencyContactsData" :key="index">
        <p class="font-weight-bolder" style="margin-bottom: 5px;">{{ section.section }}</p>
        <table class="table table-borderless" style="margin-bottom: 5px;">
          <thead>
            <tr>
              <th>{{ $t("grid.slots.info.contact_info.name") }}</th>
              <th>{{ $t("grid.slots.info.contact_info.phone") }}</th>
              <th>{{ $t("grid.slots.info.contact_info.description") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="contact in section.data"
              :key="contact.id"
            >
              <td>{{ contact.name }}</td>
              <td>{{ contact.phone_number }}</td>
              <td class="text-capitalize">{{ contact.description }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else class="table-responsive">
      <table class="table table-borderless mb-0">
        <thead>
          <tr>
            <th>{{ $t("grid.slots.info.contact_info.name") }}</th>
            <th>{{ $t("grid.slots.info.contact_info.phone") }}</th>
            <th>{{ $t("grid.slots.info.contact_info.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="contact in emergencyContactsData"
            :key="contact.id"
          >
            <td>{{ contact.name }}</td>
            <td>{{ contact.phone_number }}</td>
            <td class="text-capitalize">{{ contact.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api';

export default {
  props: {
    emergencyContacts: {
      type: Array
    }
  },
  setup (props) {
    //COMPUTED
    const emergencyContactsData = computed(() => {
      if (emergencyContactsWithSections.value) {
        const contactsSection = [];
        const sectionsMap     =  props.emergencyContacts.map(ec => ec.section);
        const sections        = [...new Set(sectionsMap)];

        for (const section of sections) {
          const contacts = {
            section,
            data: props.emergencyContacts.filter(
              ec => (ec.section === section)
            )
          }

          contactsSection.push(contacts);
        }

        return contactsSection;
      }

      return props.emergencyContacts;
    });

    const emergencyContactsWithSections = computed(() => {
      const sections = props.emergencyContacts.filter(ec => ec.section);

      if (sections.length) {
        return true;
      }

      return false;
    });

    return { emergencyContactsData,emergencyContactsWithSections }
  }
}
</script>
